<template>
    <div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Scrolling from "../libs/Scrolling"
    import {throttle} from "lodash"
    import ScrollMagic from "scrollmagic"
    import {breakpoint, breakpointDown, breakpointUp} from "../libs/Breakpoints";
    import Sticky from "sticky-js"

    export default {
        props: {},
        data() {
            return {
                controller: new ScrollMagic.Controller(),
                sceneArray: [],
                dockFiltersDuration: null,
                dockFiltersScene: null,
                asideDuration: null,
                asideScene: null,
                filterOnTop: true,
                asideSticky: null,
                filtersSticky: null,
                $targetSeeAllSessions: null
            };
        },
        methods: {
            initHashScroll() {
                if (this.$route.hash) {
                    let hash = this.$route.hash;

                    if (breakpointDownMd) {
                        Scrolling.scrollTo(hash, "easeInOutExpo", 800, -Scrolling.hauteurMenuMobile - 2)
                    } else {
                        Scrolling.scrollTo(hash)
                    }

                    // if (hash !== "#inscription") {
                    // hash = hash.substr(1);
                    // this.updateClasses(hash)
                    // }
                }
            },
            initLinksFollow() {

                // Toggle Class Menu Nav
                $(".sm-item").each((index, item) => {

                    let itemName = $(item).attr("id");

                    this.sceneArray[itemName] = new ScrollMagic.Scene({
                        triggerElement: "#" + itemName,
                        triggerHook: 0,
                        duration: $("#" + itemName).outerHeight(true),
                        offset: -$(".dock-filters").outerHeight(true)
                    })
                        .setClassToggle(".dock-filters ." + itemName, "active")
                        // .addIndicators()
                        .on("enter", (e) => {
                            this.$root.$refs["dock-filters"].selectedFilter = itemName
                        })
                        .on("leave", function (e) {

                            let $firstItemClass = $("ul.filters a")[0].classList[0]

                            if (e.scrollDirection === "REVERSE" && e.state === "BEFORE" && $(e.currentTarget.triggerElement()).hasClass($firstItemClass)) {
                                $(".dock-filters ." + $firstItemClass).addClass("active")
                            }

                        })

                        .addTo(this.controller);

                });
                this.updateDuration()

            },
            stickyFilters() {
                var marginTop = 0
                if (breakpointDown("md")) {
                    marginTop = Scrolling.hauteurMenuMobile
                }

                this.filtersSticky = new Sticky("section.dock-filters", {
                    marginTop: marginTop,
                    stickyClass: "shadow",
                    wrap: true
                });
                setTimeout(() => {
                    $(".col-left").removeAttr("style")
                }, 200)
            },
            updateClasses(hash) {
                $(".dock-filters a").removeClass("active")
                $(".dock-filters a." + hash).addClass("active")
            },
            updateDuration() {
                $("[data-accordion] .head").on("click", (event) => {
                    console.log("click")
                    event.preventDefault();
                    this.updateLinksFollowDuration()

                });
            },
            updateLinksFollowDuration() {
                setTimeout(() => {

                    $(".sm-item").each((index, item) => {
                        let itemName = $(item).attr("id");

                        let duration = $("#" + itemName).outerHeight(true);
                        this.sceneArray[itemName].duration(duration)

                    });
                    if (this.asideSticky) {
                        this.asideSticky.update()
                    }
                    if (this.filtersSticky) {
                        this.filtersSticky.update()
                    }

                }, 310)
            },
            initAsideSticky() {
                if (breakpointUp("xl")) {
                    this.asideSticky = new Sticky("section.vignette");
                }
            },
            initVignetteLinks() {
                $(document).on("click", "section.vignette .cta a[href^='#']", (e, $el) => {

                    var id = $(e.target).attr("href");
                    if ($(id).length > 0) {
                        e.preventDefault();

                        // trigger scroll
                        Scrolling.scrollTo(id, "easeInOutExpo", 800, 20);

                    }
                });
            },
            destroyDockFilters() {
                for (var key in this.sceneArray) {
                    this.sceneArray[key].destroy(true)
                }

            },
            resizeEndHandle() {
                // this.destroyDockFilters()
                // this.initLinksFollow()
                this.updateLinksFollowDuration()

                try {
                    this.cleanSpan(this.filtersSticky)
                } catch (e) {
                }

                try {
                    this.asideSticky.destroy()
                } catch (e) {
                }
                try {
                    this.filtersSticky.destroy()
                } catch (e) {
                }

                this.initAsideSticky()
                this.stickyFilters()


            },
            cleanSpan(stickyInstance) {
                stickyInstance.elements.forEach(function (element) {
                    if ($(element).parent().is("span")) {
                        $(element).unwrap()
                    }
                });

            },
            initCityVignette() {

                this.$targetSeeAllSessions = $("a.see-sessions");

                if (this.$targetSeeAllSessions.length > 0) {

                    this.$targetSeeAllSessions.on("click", (event) => {
                        event.preventDefault()
                        this.$targetSeeAllSessions.hide()
                        $("ul.sessions li.hidden").show()
                    })
                }

            }
        },
        mounted() {

            this.initLinksFollow()

            setTimeout(() => {
                this.stickyFilters()
            }, 1000);

            setTimeout(() => {
                this.initAsideSticky()
            }, 1000);

            this.initVignetteLinks()
            this.initCityVignette()

            setTimeout(() => {
                this.initHashScroll()
            }, 1300)

            $(window).bind("resizeEnd", this.resizeEndHandle);

        },
        beforeDestroy() {

            $(window).unbind("resizeEnd", this.resizeEndHandle);
            $(document).off("click")
            this.$targetSeeAllSessions.off("click")
            $("[data-accordion] .head").off("click")

            for (var key in this.sceneArray) {
                this.sceneArray[key].destroy(true)
            }

            try {
                this.cleanSpan(this.filtersSticky)
            } catch (e) {
            }

            try {
                this.asideSticky.destroy()
            } catch (e) {
            }

            try {
                this.filtersSticky.destroy()
            } catch (e) {
            }

            this.controller.destroy(true)

        }
    };
</script>
